<div
  class="basin-display-flex basin-flex-row p-ai-center basin-width-100"
  *ngIf="studyAreaStatusMessage$ | async; let status"
>
  <basin-circled-icon
    [icon]="status.icon"
    size="large"
    theme="blue"
  ></basin-circled-icon>

  <div class="basin-pl-4">
    {{ status.message }}
  </div>
</div>
